"use strict";

angular.module("licensure.services").factory("MergeTemplates", [
    "$http",
    "$q",
    function($http, $q) {
        var get = function(code, includeInactive) {
            var d = $q.defer();

            $http
                .get(apiLocation + "/api/mergetemplates", {
                    params: {
                        code: code,
                        includeInactive: includeInactive
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        };

        return {
            get: get,

            getInspectionTemplates: function() {
                return get("Inspections");
            },

            getInvestigationTemplates: function() {
                return get("Investigations");
            },

            getInspectionVisitTemplates: function() {
                return get("Inspection Visits");
            },

            getExamsTemplates: function(includeInactive) {
                return get("Exams", includeInactive);
            },

            getbyid: function(id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/mergetemplates/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function(merge_template) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/mergetemplates/";
                if (!isUndefined(merge_template.id)) {
                    method = "PUT";
                    url += merge_template.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        merge_template: merge_template
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/mergetemplates/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
